import { APP_HIDE_JIVOCHAT } from '@common/constants';
import config from '@config';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

const JIVO_SCRIPT_ID = 'jivochat-widget';
const JIVO_STYLE_ID = 'jivochat-widget-style';
const JIVO_SCRIPT_SRC = 'https://code.jivo.ru/widget/bFCagTUa2j';
const JIVO_STYLES = `
  jdiv[class*="button__"] {
    width: 56px;
    height: 56px;
    margin-right: 18px !important;
  }

  jdiv[class*="wrap__"][class*="_orientationRight__"][class*="_show__"][class*="_mobileOffsetBottom__"][class*="jivoMobileButton"] {
    --jivoMobileOffsetBottom: 115px !important;
  }

  jdiv[class*="wrap__"][class*="_orientationRight__"][class*="_show__"][class*="_desktopOffsetBottom__"] {
    --jivoDesktopOffsetBottom: 115px !important;
  }

  body.jivochat-hidden jdiv[class*="wrap__"] {
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
  }
`;

export default function JivoChat() {
  const location = useLocation();

  useEffect(() => {
    const hiddenByUserValue: string = reactLocalStorage.get(APP_HIDE_JIVOCHAT, 'false');
    const hiddenByUser = hiddenByUserValue === 'true';
    const hiddenByRoute = (
      location.pathname.startsWith('/keno/')
      || location.pathname === '/sport-games'
      || location.pathname.startsWith('/sgames/sportsbook')
    );

    const isEnabled = config.jivochat && !hiddenByUser && !hiddenByRoute;

    const removeJivoChat = () => {
      document.getElementById(JIVO_SCRIPT_ID)?.remove();
      document.querySelectorAll('jdiv').forEach((element) => element.remove());
      document.body.classList.remove('jivochat-hidden');
    };

    if (!isEnabled) {
      removeJivoChat();
      return;
    }

    if (!document.getElementById(JIVO_STYLE_ID)) {
      const style = document.createElement('style');
      style.id = JIVO_STYLE_ID;
      style.textContent = JIVO_STYLES;
      document.head.appendChild(style);
    }

    if (document.getElementById(JIVO_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement('script');
    script.id = JIVO_SCRIPT_ID;
    script.async = true;
    script.src = JIVO_SCRIPT_SRC;

    document.body.appendChild(script);
  }, [ location.pathname ]);

  return null;
}
